import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class HeaderService {
  private baseUrl: string;
  notificationsCount$: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  constructor(private http: HttpClient, @Optional() @Inject('BASE_API_URL') baseUrl?: string) {
    this.baseUrl = baseUrl ? baseUrl + '' : '';
  }

  /** get notification count */
  notificationCount(): Observable<any> {
    const url = `${this.baseUrl}enterprise/notification-count`;
    return this.http.get(url);
  }

}
